module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_red.09cf7dd2.png";